import { render, staticRenderFns } from "./MsgPurple.vue?vue&type=template&id=236ffc10&scoped=true"
import script from "./MsgPurple.vue?vue&type=script&lang=js"
export * from "./MsgPurple.vue?vue&type=script&lang=js"
import style0 from "./MsgPurple.vue?vue&type=style&index=0&id=236ffc10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ffc10",
  null
  
)

export default component.exports